import React, { useEffect, useState } from "react";
import "react-day-picker/dist/style.css";
import { HiOutlineTicket } from "react-icons/hi";
import { MdArrowForward } from "react-icons/md";
import { Assort } from "../../../models/Assort";
import { TicketAccess } from "../../../models/TicketAccess";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import "./style.scss";
import { BasketItem } from "../../../models/BasketItem";
import { useTranslation } from "react-i18next";
import CalendarPassReservaton from "./calendarPassReservation";
import { Exercise } from "../../../models/Exercise";
import useFacility from "../../../../utils/hooks/useFacility";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { QntStateItem } from "../../../models/QntStateItem";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import EAButton from "../../shared/Buttons/EAButton";
import useCustomOffer from "../../CustomOffer/hooks/useCustomOffer";
import CoachInfoAssort from "./CoachInfoAssort";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import getId from "../../../../utils/getId";
import { isKarnetTestFacility } from "../../CourtGrid/components/CourtReservationModal/CourtTicketSelection/karnetConcept";
import KarnetSection from "../../CourtGrid/components/CourtReservationModal/CourtTicketSelection/KarnetSection";
import KarnetTermsConfirmation from "../../CourtGrid/components/CourtReservationModal/CourtTicketSelection/KarnetTermsConfirmation";
import useCalendarKarnetPurchase from "./useCalendarKarnetPurchase";

interface IProps {
  tickets: Assort[];
  ticketAccess: TicketAccess;
  ticketLimit: number;
  refreshCapacityAfterAddTicket: () => void;
  exerciseDetails?: Exercise;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  alertCalendar: string;
  // Opcjonalne propsy dla limitów asortymentowych (GET_EXERCISE_ASSORT_LIMITS)
  getLimitForAssort?: (assortId: string, exerciseGroupId: string) => number | null;
  isFallback?: boolean;
  isLimitsLoading?: boolean;
  globalLimitOverride?: number;
  exerciseGroupCompositeId?: string; // format: "objectDb,objectId" grupy zajęciowej
}
const CalendarAssorts: React.FC<IProps> = ({
  tickets,
  ticketLimit,
  ticketAccess,
  refreshCapacityAfterAddTicket,
  joinToExerciseByPass,
  exerciseDetails,
  alertCalendar,
  getLimitForAssort,
  isFallback,
  isLimitsLoading,
  globalLimitOverride,
  exerciseGroupCompositeId,
}: IProps) => {
  const { t } = useTranslation();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const { getBasket } = useBasketManager();
  const [, setAllowToAssign] = useState(false);
  const facilityIds = useFacility();
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const { getSaleStepByStepId } = useCustomOffer();
  const foundedSaleStep = getSaleStepByStepId();
  const globalShowTicketsPool = useSelector(
    (state: State) => state.config.configuration.showTicketsPoolForStepByStepSale
  );

  const showTicketsPool = foundedSaleStep?.showOtherTicketsPool || globalShowTicketsPool;
  const saleStepAllowToSignByPass = foundedSaleStep?.allowToSignByPass;

  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
    setTimeout(() => {
      refreshCapacityAfterAddTicket();
    }, 300);
  };

  const hasKarnetEligibleInBasket = isKarnetTestFacility(facilityIds) && preBasket.some((item) => item.qnt > 0);
  const karnet = useCalendarKarnetPurchase({
    exerciseDetails: exerciseDetails ?? null,
    anchorTicketAccess: ticketAccess,
    preBasket,
    onPurchased: handleDeleteBasket,
  });
  const sumBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const ticketsInCurrentBasket = () => {
    if (qntState && qntState.length > 0) {
      return qntState
        .filter((item) => item.exerciseIds === ticketAccess.exerciseIds)
        .reduce((acc: number, item: QntStateItem) => acc + item.count, 0);
    } else {
      return preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);
    }
  };

  const asignByPass = (assigned: boolean, passId: number) => {
    joinToExerciseByPass(ticketAccess.exerciseIds, assigned, passId);
  };

  useEffect(() => {
    if (facilityIds === "1212" || facilityIds === "1246") {
      setAllowToAssign(true);
    }
    //eslint-disable-next-line
  }, [facilityIds]);

  // Gdy limity asortymentowe są załadowane i nie ma fallbacku, używamy globalLimitOverride
  const useLimitsApi = isFallback === false && !isLimitsLoading && globalLimitOverride !== undefined;
  const effectiveLimit = useLimitsApi ? globalLimitOverride! : ticketLimit;

  if (karnet.step === "confirm") {
    return (
      <KarnetTermsConfirmation
        terms={karnet.selectedTerms}
        availableCount={karnet.availableTerms.length}
        unavailableCount={karnet.unavailableCount}
        totalPrice={sumBasket() * karnet.availableTerms.length}
        isAdding={karnet.isAdding}
        addError={karnet.addError}
        onConfirm={karnet.confirmPurchase}
        onBack={karnet.backToSelect}
      />
    );
  }

  return (
    <>
      {tickets.length > 0 ? (
        <>
          {tickets.map((item, index) => {
            const assortLimit =
              useLimitsApi && getLimitForAssort && exerciseGroupCompositeId
                ? getLimitForAssort(getId(item), exerciseGroupCompositeId)
                : undefined;
            const isUnavailable = assortLimit === 0;

            return (
              <div
                className={`calendar-sale-ticket${isUnavailable ? " ticket-block--unavailable" : ""}`}
                key={index}
              >
                <TicketLineSummary
                  item={item}
                  exercise={ticketAccess}
                  preBasket={preBasket}
                  addItemToBasket={addItemToBasket}
                  removeItemFromBasket={removeItemFromBasket}
                  setItemQuantity={setItemQuantity}
                  ticketLimit={useLimitsApi ? undefined : ticketLimit}
                  eventCapacityLimit={useLimitsApi ? globalLimitOverride : undefined}
                  assortSpecificLimit={assortLimit}
                  qntState={qntState}
                  allowManualInput={true}
                />
              </div>
            );
          })}

          {effectiveLimit === ticketsInCurrentBasket() && (
            <div className="flex-between-center alert alert-red ">
              <b>{t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")}</b>
            </div>
          )}
          {exerciseDetails && (
            <>
              {saleStepAllowToSignByPass && (
                <CalendarPassReservaton
                  exerciseDetails={exerciseDetails}
                  asignByPass={asignByPass}
                  alertCalendar={alertCalendar}
                />
              )}
            </>
          )}

          {showTicketsPool && (
            <div className="flex-between-center alert alert-second ">
              <b>
                {t("na_to_wejscie_obowiazuje_limit_biletow_pozostalo")}{" "}
                {effectiveLimit > 0 ? effectiveLimit - ticketsInCurrentBasket() : 0}
              </b>
              <HiOutlineTicket className="alert-icon" />
            </div>
          )}
        </>
      ) : (
        <EASkeletonLoader height="100px" />
      )}

      {exerciseDetails && (
        <CoachInfoAssort
          humanName={exerciseDetails.humanName}
          humanPicture={exerciseDetails.humanPicture}
          deputyHumanIds={exerciseDetails.deputyHumanIds}
          deputyHumanName={exerciseDetails.deputyHumanName}
          deputyHumanLastName={exerciseDetails.deputyHumanLastName}
        />
      )}

      {hasKarnetEligibleInBasket && (
        <KarnetSection
          enabled={karnet.enabled}
          onToggle={karnet.toggleEnabled}
          clampedRepeats={karnet.clampedRepeats}
          onRepeatsChange={karnet.setRepeats}
          horizonCount={karnet.schedule.horizonCount}
          lastAvailableDateLabel={karnet.schedule.lastAvailableDateLabel}
          loading={karnet.schedule.loading}
          perTermPrice={sumBasket()}
        />
      )}

      {karnet.enabled ? (
        <div className="pre-basket-summary__container">
          <span className="body-text-large">
            {t("suma")}:{" "}
            <b>
              {(sumBasket() * karnet.clampedRepeats).toFixed(2)} {t("zl")}
            </b>
          </span>
          <div className="pre-basket-summary__buttons">
            <EAButton
              title="Dalej — sprawdź terminy"
              onClick={karnet.goToConfirmation}
              endIcon={<MdArrowForward />}
              disabled={karnet.schedule.loading || karnet.clampedRepeats < 1}
            />
          </div>
        </div>
      ) : (
        <PreBasketSummary
          ticketLimit={effectiveLimit}
          preBasket={preBasket}
          clearBasket={handleDeleteBasket}
          qntState={qntState}
        />
      )}
    </>
  );
};

export default CalendarAssorts;
